module.exports = __webpack_public_path__ + "img/slidedata-image-1.9ea39c20.jpg";